import type { ApiClient } from "../../../infrastructure/http/apiClient";
import { ApiClientError } from "../../../infrastructure/http/apiClient";
import type { AuthenticatedUserContext } from "../domain/session";

const AUTH_ME_PATH = "/api/v1/auth/me";

export async function getAuthMe(apiClient: ApiClient): Promise<AuthenticatedUserContext> {
  const response = await apiClient.get<unknown>(AUTH_ME_PATH);

  if (!isAuthenticatedUserContext(response)) {
    throw new ApiClientError("The auth/me response did not match the expected contract.", {
      code: "invalid_response"
    });
  }

  return response;
}

function isAuthenticatedUserContext(value: unknown): value is AuthenticatedUserContext {
  return isRecord(value)
    && typeof value.user_id === "string"
    && typeof value.email === "string"
    && typeof value.tenant_id === "string"
    && typeof value.role === "string";
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
